import {match} from 'ts-pattern';

import {isNotNil} from 'ramda';

import {TimeType} from '../../../types/TimeType';
import {getTimeFromDate} from '../../../utils/getTimeFromDate';
import {TranslationInterpreter} from '../../TranslationProvider/TranslationProvider';
import {RelativeTimeOption, ResolvedRelativeTime} from '../types/RelativeTime';
import {isTimeDisabled} from './isTimeDisabled';

const NOW_LABEL_KEY = 'general.labels.now';

interface ResolveRelativeTimesParams {
  relativeTimes: RelativeTimeOption[];
  now: Date;
  minTime: TimeType | undefined;
  maxTime: TimeType | undefined;
  formatTimeLabel: (time: TimeType) => string;
  t: TranslationInterpreter;
}

export function resolveRelativeTimes(params: ResolveRelativeTimesParams): ResolvedRelativeTime[] {
  return params.relativeTimes
    .map((option) =>
      match<RelativeTimeOption, ResolvedRelativeTime>(option)
        .with('currentTime', () => {
          const nowTime = getTimeFromDate(params.now);
          return {
            time: nowTime,
            label: params.t(NOW_LABEL_KEY),
            suffix: params.formatTimeLabel(nowTime),
            isNow: true,
          };
        })
        .otherwise((relativeTime) => ({
          time: relativeTime.time,
          label: relativeTime.label ?? params.formatTimeLabel(relativeTime.time),
          suffix: isNotNil(relativeTime.label)
            ? params.formatTimeLabel(relativeTime.time)
            : undefined,
          isNow: false,
        }))
    )
    .filter((chip) => !isTimeDisabled(chip.time, params.minTime, params.maxTime));
}
